import InnerComponent from '@Components/Purchase/PurchaseRequests/CreatePurchaseRequest';
import orgContainer from '@Components/AppContainer';

const CreatePurchaseRequest = () => ((orgContainer(InnerComponent)));
export default CreatePurchaseRequest;
